export function emailIsValid (email) {
  if (!email ) return

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}